import { render } from "./TicketCenter.vue?vue&type=template&id=6de09fba&scoped=true"
import script from "./TicketCenter.vue?vue&type=script&lang=js"
export * from "./TicketCenter.vue?vue&type=script&lang=js"

import "./TicketCenter.vue?vue&type=style&index=0&id=6de09fba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de09fba"]])

export default __exports__